import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = { class: "flex-grow-1" }
const _hoisted_3 = { class: "text-caption font-weight-bold" }
const _hoisted_4 = { class: "text-caption" }
const _hoisted_5 = { class: "text-caption" }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 0,
  class: "text-caption text-error"
}

import { computed, ref } from 'vue';
import type { RequestStats } from '@/esri/services/TempoDataService';

interface Props {
  stats: RequestStats[];
  height?: number;
  selectedStat?: RequestStats | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TimeRangeStatusList',
  props: {
    stats: {},
    height: { default: 400 },
    selectedStat: { default: null }
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const statusFilter = ref<'all' | 'success' | 'error'>('all');

const allStats = computed(() => props.stats);

const successCount = computed(() => 
  props.stats.filter(s => s.status === 'success').length
);

const errorCount = computed(() => 
  props.stats.filter(s => s.status === 'error').length
);

const filteredStats = computed(() => {
  if (statusFilter.value === 'all') {
    return props.stats;
  }
  return props.stats.filter(s => s.status === statusFilter.value);
});

function formatTimeRange(range: { start: number; end: number }): string {
  const start = new Date(range.start);
  const end = new Date(range.end);
  
  const dateFormat: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  };
  
  return `${start.toLocaleDateString('en-US', dateFormat)} - ${end.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}`;
}

function getStatusClass(stat: RequestStats): string {
  return stat.status === 'success' ? 'status-success' : 'status-error';
}

function getStatusColor(stat: RequestStats): string {
  if (stat.status === 'success') return 'success';
  if (stat.errorType === '503') return 'warning';
  return 'error';
}

function getRetryLabel(stat: RequestStats): string {
  if (stat.retriedFrom503) {
    return stat.status === 'success' 
      ? '(Retried from 503 ✓)' 
      : '(Retried from 503 ✗)';
  }
  return stat.status === 'success'
    ? '(Retried ✓)'
    : '(Retried ✗)';
}

function getRetryClass(stat: RequestStats): string {
  if (stat.status === 'success') {
    return 'text-success font-weight-bold';
  }
  return 'text-error font-weight-bold';
}

function getInspectUrl(url: string): string {
  // Replace f=pjson with f=html to get the human-readable version
  return url.replace('f=pjson', 'f=html');
}

function handleItemClick(stat: RequestStats) {
  emit('select', stat);
}

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "time-range-status-list" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "text-h6 d-flex align-center" }, {
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createTextVNode(" Time Range Status ", -1)),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_chip_group, {
            modelValue: statusFilter.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((statusFilter).value = $event)),
            mandatory: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_chip, {
                value: "all",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("All (" + _toDisplayString(allStats.value.length) + ")", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_chip, {
                value: "success",
                size: "small",
                color: "success"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Success (" + _toDisplayString(successCount.value) + ")", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_chip, {
                value: "error",
                size: "small",
                color: "error"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Failed (" + _toDisplayString(errorCount.value) + ")", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "pa-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_virtual_scroll, {
            items: filteredStats.value,
            height: __props.height,
            "item-height": "80"
          }, {
            default: _withCtx(({ item }) => [
              _createVNode(_component_v_card, {
                class: _normalizeClass(['time-range-card ma-2', getStatusClass(item), { 'selected': item === props.selectedStat }]),
                variant: "outlined",
                density: "compact",
                onClick: ($event: any) => (handleItemClick(item)),
                style: {"cursor":"pointer"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "pa-2" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_v_icon, {
                          icon: item.status === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle',
                          color: item.status === 'success' ? 'success' : 'error',
                          class: "mr-2"
                        }, null, 8, ["icon", "color"]),
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, _toDisplayString(formatTimeRange(item.timeRange)), 1),
                          _createElementVNode("div", _hoisted_4, [
                            _createTextVNode(" Duration: " + _toDisplayString(item.duration.toFixed(0)) + "ms | Samples: " + _toDisplayString(item.sampleCount) + " ", 1),
                            (item.retried)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass(getRetryClass(item))
                                }, _toDisplayString(getRetryLabel(item)), 3))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("a", {
                              href: getInspectUrl(item.url),
                              target: "_blank",
                              class: "text-primary text-decoration-none",
                              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _createVNode(_component_v_icon, {
                                size: "x-small",
                                class: "mr-1"
                              }, {
                                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                  _createTextVNode("mdi-open-in-new", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[4] || (_cache[4] = _createTextVNode(" Inspect Request ", -1))
                            ], 8, _hoisted_6)
                          ]),
                          (item.status === 'error')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("strong", null, _toDisplayString(item.errorType) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(item.errorMessage || 'Unknown error'), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_v_chip, {
                          color: getStatusColor(item),
                          size: "x-small",
                          variant: "flat"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.status), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"])
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["class", "onClick"])
            ]),
            _: 1
          }, 8, ["items", "height"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})